import React, { useMemo, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useAlert } from "react-alert";
import * as Sentry from "@sentry/browser";

import { makeRequest } from "./util";
import useFirstDestinationOfType from "./hooks/useFirstDestinationOfType";

// TODO CJ This should accept a destination id
export const DestinationOAuth = ({ destinationURL, destinationName }) => {
  const params = new URLSearchParams(useLocation().search);
  const history = useHistory();
  const alert = useAlert();
  const destination = useFirstDestinationOfType(destinationName);
  const destUrl = useMemo(() => {
    return destination ? `${destinationURL}/${destination.id}` : destinationURL;
  }, [destinationURL, destination]);

  const [completeOauthRequested, setCompleteOauthRequested] = useState(false);

  if (!destination) {
    return null;
  }

  if (completeOauthRequested) {
    return null;
  }

  setCompleteOauthRequested(true);

  const errorURL = `${destUrl}?error=Failed+to+complete+OAuth`;

  if (!params.get("state")) {
    const err = new Error("Unable to find 'state' parameter for OAuth.");
    console.log(err);
    Sentry.captureException(err);
    alert.error("Failed to complete OAuth");
    history.push(errorURL);
  }

  if (!params.get("code")) {
    const err = new Error("Unable to find 'code' parameter for OAuth.");
    console.log(err);
    Sentry.captureException(err);
    alert.error("Failed to complete OAuth");
    history.push(errorURL);
  }

  // if code last two chars are #_, then remove those for reddit-ads
  if (destinationName === "reddit-ads") {
    const code = params.get("code");
    if (code.slice(-2) === "#_") {
      params.set("code", code.slice(0, -2));
    }
  }

  const request = {
    integration_name: destinationName,
    state: params.get("state"),
    code: params.get("code"),
  };

  // TODO CJ This should pass the destination id in the request
  makeRequest("complete_oauth_flow", request)
    .then(() => {
      if (!destinationURL) {
        window.close();
      } else {
        history.push(destUrl);
      }
    })
    .catch((err) => {
      console.log(err);
      alert.error("Failed to complete OAuth");
      Sentry.captureException(err);
      history.push(errorURL);
    });

  return null;
};
